import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Tabs,
  Select,
  Spin,
  Switch,
} from "antd";
import axios from "services/axios";
import RolePicker from "comp/RolePicker";
import Lightbox from "react-image-lightbox";

const FormItem = Form.Item;
const { TabPane } = Tabs;
const { Option } = Select;

class UserUpdate extends Component {
  constructor(props) {
    super(props);
    this.fileInputKTP = React.createRef();
    this.fileInputNPWP = React.createRef();
    this.state = {
      supervisors: [],
      branches: [],
      areaBranches: [],
      areaBusinesses: [],
      tntUsers: [],
      mobbiSupervisors: [],
      managers: [],
      loading: false,
      role: "",
      user: {},
      profile: {},
      changePassword: false,
      npwpImage: null,
      ktpImage: null,
      visibleModalKTP: false,
      visibleModalNPWP: false,
    };
  }

  triggerInputFile = (type) => {
    if (type == "ktp") {
      if (this.fileInputKTP.current && this.fileInputKTP.current.click) {
        this.fileInputKTP.current.click();
      }
    } else {
      if (this.fileInputNPWP.current && this.fileInputNPWP.current.click) {
        this.fileInputNPWP.current.click();
      }
    }
  };

  setSelectedImage(image, type) {
    if (image == null) this.state.profile[type] = null;
    if (type === "ktp") {
      this.setState({ ktpImage: image });
    } else {
      this.setState({ npwpImage: image });
    }
  }

  visibleModal(type, val) {
    switch (type) {
      case "ktp":
        this.setState({ visibleModalKTP: val });
        break;
      case "npwp":
        this.setState({ visibleModalNPWP: val });
        break;
    }
  }

  // Untuk Other, appraisal, pricing //
  handleSubmit = (e) => {
    let self = this;
    const { user } = this.state;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let userData = {
          name: values.name,
          email: values.email,
          phone: values.phone,
          role: user.role,
          id: user.id,
        };
        if (values.password) userData.password = values.password;

        let id = this.props.match.params.id;
        axios
          .put(`/admin-panel/user/update-other/${id}`, userData)
          .then((result) => {
            message.success(
              `Berhasil update user ${values.name} dengan role ${user.role}`
            );
            self.setState({ loading: false });
            this.props.history.push(
              `/home/${this.props.location.query.role}-user`
            );
          })
          .catch((err) => {
            this.errorMessage(err);
            self.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
      }
    });
  };

  // Untuk Appraiser//
  updateAppraiser = (e) => {
    let self = this;
    const { user } = this.state;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let userData = {
          name: values.name,
          email: values.email,
          phone: values.phone,
          role: user.role,
          id: user.id,
          isDisableAppraisal: !values.isDisableAppraisal,
        };
        if (values.password) userData.password = values.password;

        let id = this.props.match.params.id;
        axios
          .put(`/admin-panel/user/update-appraiser/${id}`, userData)
          .then((result) => {
            message.success(
              `Berhasil update user ${values.name} dengan role ${user.role}`
            );
            self.setState({ loading: false });
            this.props.history.push(
              `/home/${this.props.location.query.role}-user`
            );
          })
          .catch((err) => {
            this.errorMessage(err);
            self.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
      }
    });
  };

  // Untuk Salesman //
  updateSales = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.nrp) {
        if (!err) {
          const { profile, npwpImage, ktpImage } = this.state;

          let id = this.props.match.params.id;
          let dataField = [
            "name",
            "email",
            "password",
            "phone",
            "nrp",
            "branchId",
            "supervisorId",
            "noNPWP",
            "noKTP",
            "bankName",
            "bankAccNo",
            "bankBeneficiary",
            "whatsapp",
          ];

          let dataUser = new FormData();
          for (let i = 0; i < dataField.length; i++) {
            let value = values[dataField[i]];
            if (value) {
              if (dataField[i] == "branchId" && Array.isArray(value)) {
                dataUser.append("branchId", JSON.stringify(value));
              } else {
                dataUser.append(dataField[i], value);
              }
            }
          }
          if (npwpImage) dataUser.append("NPWP", npwpImage);
          if (ktpImage && ktpImage !== profile.ktp) {
            dataUser.append("KTP", ktpImage);
          }

          axios
            .put(`/admin-panel/user/update-sales/${id}`, dataUser)
            .then((result) => {
              if (result.data.success) {
                message.success(`Berhasil update Sales ${values.name}`);
                this.props.history.push(
                  `/home/${this.props.location.query.role}-user`
                );
              } else {
                message.error(result.data.message);
                this.setState({ loading: false });
              }
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          // message.error(err);
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`NRP wajib diisi`);
      }
    });
  };

  // Untuk TNT Dan Kacab //
  updateUser = (e, role) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        if (!err) {
          let id = this.props.match.params.id;
          let dataUser;

          // Role Kacab //
          if (role == "branch-head") {
            let { npwpImage, ktpImage } = this.state;

            // Field List //
            let dataField = [
              "name",
              "email",
              "password",
              "phone",
              "nrp",
              "branchId",
              "noNPWP",
              "noKTP",
              "bankName",
              "bankAccNo",
              "bankBeneficiary",
              "whatsapp",
            ];

            // Form Data //
            dataUser = new FormData();

            // Set data to form //
            for (let i = 0; i < dataField.length; i++) {
              let value = values[dataField[i]];
              if (value) {
                // Jika Branch Id Array
                if (dataField[i] == "branchId" && Array.isArray(value)) {
                  dataUser.append("branchId", JSON.stringify(value));
                } else {
                  dataUser.append(dataField[i], value);
                }
              }
            }

            if (npwpImage) dataUser.append("NPWP", npwpImage);
            if (ktpImage) dataUser.append("KTP", ktpImage);
          } else if (role === "mobbi-supervisor") {
            dataUser = {
              name: values.name,
              email: values.email,
              phone: values.phone,
              password: values.password,
              branchIds: values.branchId,
            };
          } else {
            // Role TNT //
            dataUser = {
              name: values.name,
              email: values.email,
              nrp: values.nrp,
              phone: values.phone,
              password: values.password,
              branchId: values.branchId,
            };

            if (role == "tnt") {
              dataUser.branchId = JSON.stringify(values.branchId);
            }
          }

          axios
            .put(`/admin-panel/user/update-${role}/${id}`, dataUser)
            .then((result) => {
              message.success(
                `Berhasil menambah ${this.props.location.query.user} ${values.name}`
              );
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  // Untuk BOH //
  updateBOH = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        if (!err) {
          const { profile, npwpImage, ktpImage } = this.state;

          let id = this.props.match.params.id;
          let dataField = [
            "name",
            "email",
            "password",
            "phone",
            "areaBranchId",
            "noNPWP",
            "noKTP",
            "bankName",
            "bankAccNo",
            "bankBeneficiary",
            "whatsapp",
          ];

          let formData = new FormData();
          for (let i = 0; i < dataField.length; i++) {
            if (values[dataField[i]]) {
              formData.append(dataField[i], values[dataField[i]]);
            }
          }
          if (npwpImage) formData.append("NPWP", npwpImage);
          if (ktpImage && ktpImage !== profile.ktp) {
            formData.append("KTP", ktpImage);
          }

          axios
            .put(`/admin-panel/user/update-boh/${id}`, formData)
            .then((result) => {
              message.success(`Berhasil Update BOH ${values.name}`);
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  // Untuk Director //
  updateABM = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        if (!err) {
          let id = this.props.match.params.id;

          axios
            .put(`/admin-panel/user/update-abm/${id}`, values)
            .then((result) => {
              message.success(`Berhasil Update ABM ${values.name}`);
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  // Untuk Supervisor //
  updateSupervisor = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        if (!err) {
          let { profile, npwpImage, ktpImage } = this.state;

          // Field List //
          let dataField = [
            "name",
            "email",
            "password",
            "phone",
            "nrp",
            "branchId",
            "noNPWP",
            "noKTP",
            "bankName",
            "bankAccNo",
            "bankBeneficiary",
            "whatsapp",
          ];

          // Form Data //
          let dataUser = new FormData();

          // Set data to form //
          for (let i = 0; i < dataField.length; i++) {
            let value = values[dataField[i]];
            if (value) {
              dataUser.append(dataField[i], value);
            }
          }

          if (npwpImage) dataUser.append("NPWP", npwpImage);
          if (ktpImage) dataUser.append("KTP", ktpImage);
          axios
            .put(
              `/admin-panel/user/update-supervisor/${this.props.match.params.id}`,
              dataUser
            )
            .then((result) => {
              message.success(`Berhasil Update Supervisor ${values.name}`);
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  componentDidMount() {
    this.fetchUser();
    this.fetchBranch();
    this.fetchAreaBranch();
    this.fetchAreaBusiness();
    this.fetchSupervisor();
    this.fetchMobbiSupervisor();
    this.fetchTNT();
    this.getFieldImage();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update User");
      }
    } else {
      message.error("Error Update User");
    }
  }

  async fetchUser() {
    const {
      match: { params },
    } = this.props;
    const {
      data: { user, profile },
    } = await axios.get(`/admin-panel/user/detail/${params.id}`);
    this.setState({ user, profile, role: user.role });
  }

  async fetchBranch() {
    const {
      data: { branches },
    } = await axios.get(`/misc/branches`);
    this.setState({ branches });
  }

  async fetchAreaBranch() {
    const {
      data: { areaBranches },
    } = await axios.get(`/misc/area-branches`);
    this.setState({ areaBranches });
  }

  async fetchAreaBusiness() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-business`);
    this.setState({ areaBusinesses: areas });
  }

  async fetchSupervisor() {
    const {
      data: { supervisors },
    } = await axios.get(`/misc/supervisors`);
    this.setState({ supervisors });
  }

  async fetchTNT() {
    const {
      data: { tntUsers },
    } = await axios.get(`/misc/tnt-users`);
    this.setState({ tntUsers });
  }

  async fetchMobbiSupervisor() {
    const {
      data: { mobbiSupervisors },
    } = await axios.get(`/misc/mobbi-supervisors`);
    this.setState({ mobbiSupervisors });
  }

  getFieldImage() {
    let { profile } = this.state;
    if (profile) {
      if (profile.ktp) this.setState({ ktpImage: profile.ktp });
      if (profile.npwp) this.setState({ npwpImage: profile.npwp });
    }
  }

  // Get Branch //
  getBranch(profile, role) {
    let branch = [];
    let objBranches = [];
    if (profile) {
      // Check Role
      if (role === "branch-head" || role === "mobbi-supervisor") {
        objBranches = profile.Branches;
      } else if (role === "tnt") {
        objBranches = profile.SalesBranches;
      }

      // Push branch
      if (Array.isArray(objBranches)) {
        objBranches.map((v) => {
          if (v && v.id) {
            branch.push(v.id);
          }
        });
      }
    }
    return branch;
  }

  // Get TNT //
  getTNT(profile) {
    let tnt = [];

    if (profile && Array.isArray(profile.TNTUsers)) {
      profile.TNTUsers.map((v) => {
        if (v && v.userId) {
          tnt.push(v.userId);
        }
      });
    }

    return tnt;
  }

  getDataProfile(profile, obj) {
    let data;
    if (profile && profile[obj]) {
      data = profile[obj];
    }
    return data;
  }

  callback(key, props) {
    props.form.resetFields();
  }

  formComponent(status) {
    const { getFieldDecorator } = this.props.form;
    const { user, profile } = this.state;
    let formNrp,
      formMultipleBranch,
      formBranch,
      formArea,
      formSupervisor,
      formNoWhatsapp,
      formBankName,
      formBankAcc,
      formBankBeneficiary,
      formNoKTP,
      formNoNPWP,
      formKTPImage,
      formNPWPImage,
      showKTPImage,
      showNPWPImage,
      formDisableAppraisal;

    // Form Name //
    let formName = (
      <FormItem label="Nama">
        {getFieldDecorator("name", {
          initialValue: user.name,
          rules: [{ required: true, message: "Nama wajib diisi" }],
        })(<Input />)}
      </FormItem>
    );

    // Form Email //
    let formEmail = (
      <FormItem label="Email">
        {getFieldDecorator("email", {
          initialValue: user.email,
          rules: [
            {
              required: true,
              type: "email",
              message: "Plase input valid email format",
            },
          ],
        })(<Input type="email" />)}
      </FormItem>
    );

    // Form Upload //
    if (["branch-head", "sales", "supervisor", "boh"].includes(status)) {
      let { npwpImage, ktpImage } = this.state;

      // Image NPWP Obj //
      let npwp = npwpImage
        ? URL.createObjectURL(npwpImage)
        : this.getDataProfile(profile, "npwp");

      // Image KTP Obj //
      let ktp = ktpImage
        ? URL.createObjectURL(ktpImage)
        : this.getDataProfile(profile, "ktp");

      // Form NRP //
      if (["branch-head", "sales", "supervisor"].includes(status)) {
        formNrp = (
          <FormItem label="NRP">
            {getFieldDecorator("nrp", {
              initialValue: user.nrp,
              rules: [
                {
                  required: true,
                  message: "NRP wajib diisi",
                },
              ],
            })(<Input />)}
          </FormItem>
        );
      }

      // Form Whatsapp //
      if (status === "sales") {
        formNoWhatsapp = (
          <FormItem label="No. Whatsapp">
            {getFieldDecorator("whatsapp", {
              initialValue: this.getDataProfile(profile, "whatsapp"),
            })(<Input />)}
          </FormItem>
        );
      }

      // Form NPWP Image //
      formNPWPImage = (
        <FormItem label="Foto NPWP">
          {npwp && (
            <img
              alt="NPWP Image"
              width={"300px"}
              height={"250px"}
              style={{ objectFit: "cover", cursor: "pointer" }}
              src={npwp}
              onClick={() => this.visibleModal("npwp", true)}
            />
          )}
          <div style={{ marginTop: 5 }}>
            {npwp && (
              <Button
                style={{ marginRight: 5 }}
                type="danger"
                onClick={() => this.setSelectedImage(null, "npwp")}>
                Remove
              </Button>
            )}

            <input
              ref={this.fileInputNPWP}
              type="file"
              name="file"
              style={{ display: "none" }}
              accept="image/*"
              onChange={(event) => {
                this.setSelectedImage(event.target.files[0], "npwp");
              }}
            />

            <Button
              type="primary"
              onClick={() => this.triggerInputFile("npwp")}>
              Upload NPWP
            </Button>
          </div>
        </FormItem>
      );

      // Form KTP Image //
      formKTPImage = (
        <FormItem label="KTP Image">
          {ktp && (
            <img
              alt="KTP Image"
              width={"300px"}
              height={"250px"}
              style={{ objectFit: "cover", cursor: "pointer" }}
              src={ktp}
              onClick={() => this.visibleModal("ktp", true)}
            />
          )}
          <div style={{ marginTop: 5 }}>
            {ktp && (
              <Button
                style={{ marginRight: 5 }}
                type="danger"
                onClick={() => this.setSelectedImage(null, "ktp")}>
                Remove
              </Button>
            )}

            <input
              ref={this.fileInputKTP}
              type="file"
              name="file"
              style={{ display: "none" }}
              accept="image/*"
              onChange={(event) => {
                this.setSelectedImage(event.target.files[0], "ktp");
              }}
            />

            <Button type="primary" onClick={() => this.triggerInputFile("ktp")}>
              Upload KTP
            </Button>
          </div>
        </FormItem>
      );

      // Show KTP Image //
      showKTPImage = this.state.visibleModalKTP && (
        <Lightbox
          mainSrc={ktp}
          onCloseRequest={() => this.visibleModal("ktp", false)}
        />
      );

      // Show NPWP Image //
      showNPWPImage = this.state.visibleModalNPWP && (
        <Lightbox
          mainSrc={npwp}
          onCloseRequest={() => this.visibleModal("npwp", false)}
        />
      );

      // Form Bank Name //
      formBankName = (
        <FormItem label="Bank">
          {getFieldDecorator("bankName", {
            initialValue: this.getDataProfile(profile, "bankName"),
          })(<Input />)}
        </FormItem>
      );

      // Form Bank Acc //
      formBankAcc = (
        <FormItem label="No. Rekening">
          {getFieldDecorator("bankAccNo", {
            initialValue: this.getDataProfile(profile, "bankAccNo"),
          })(<Input />)}
        </FormItem>
      );

      // Form Beneficiary //
      formBankBeneficiary = (
        <FormItem label="Nama Pemilik Rekening">
          {getFieldDecorator("bankBeneficiary", {
            initialValue: this.getDataProfile(profile, "bankBeneficiary"),
          })(<Input />)}
        </FormItem>
      );

      // Form No KTP //
      formNoKTP = (
        <FormItem label="No. KTP">
          {getFieldDecorator("noKTP", {
            initialValue: this.getDataProfile(profile, "noKTP"),
          })(<Input />)}
        </FormItem>
      );

      // Form No NPWP //
      formNoNPWP = (
        <FormItem label="No. NPWP">
          {getFieldDecorator("noNPWP", {
            initialValue: this.getDataProfile(profile, "noNPWP"),
          })(<Input />)}
        </FormItem>
      );
    }

    // Form Password //
    let formPassword = (
      <FormItem label="Password">
        {getFieldDecorator("password", {})(<Input type="password" />)}
      </FormItem>
    );

    // Form No Handphone //
    let formPhone = (
      <FormItem label="Nomor Handphone">
        {getFieldDecorator("phone", {
          initialValue: user.phone,
          rules: [{ required: true, message: "Nomor Handphone wajib diisi" }],
        })(<Input />)}
      </FormItem>
    );

    // Form Branch //
    if (["sales", "supervisor"].includes(status)) {
      formBranch = (
        <FormItem label="Cabang">
          {getFieldDecorator("branchId", {
            initialValue: profile ? profile.branchId : null,
          })(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a branch">
              {this.state.branches.map((branch, index) => (
                <Option key={index} value={branch.id}>
                  {branch.partnerName}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Multiple Branch //
    if (["branch-head", "tnt", "mobbi-supervisor"].includes(status)) {
      formMultipleBranch = (
        <FormItem label="Cabang">
          {getFieldDecorator("branchId", {
            initialValue: this.getBranch(profile, status),
          })(
            <Select
              showSearch
              mode="multiple"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a branch">
              {this.state.branches.map((branch, index) => (
                <Option key={index} value={branch.id}>
                  {branch.partnerName}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Area //
    if (["boh"].includes(status)) {
      formArea = (
        <FormItem label="Area">
          {getFieldDecorator("areaBranchId", {
            initialValue: profile
              ? profile.AreaBranch
                ? profile.AreaBranch.id
                : null
              : null,
          })(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a area">
              {this.state.areaBranches.map((area, index) => (
                <Option key={index} value={area.id}>
                  {area.name}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Area //
    if (["abm"].includes(status)) {
      formArea = (
        <FormItem label="Area">
          {getFieldDecorator("areaBusinessId", {
            initialValue: profile
              ? profile.AreaBusiness
                ? profile.AreaBusiness.id
                : null
              : null,
          })(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a area">
              {this.state.areaBusinesses.map((area, index) => (
                <Option key={index} value={area.id}>
                  {area.area}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Supervisor //
    if (["sales"].includes(status)) {
      formSupervisor = (
        <FormItem label="Supervisor">
          {getFieldDecorator("supervisorId", {
            initialValue: profile ? profile.supervisorId : null,
          })(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a person">
              {this.state.supervisors.map((spv, index) => (
                <Option key={index} value={spv.id}>
                  {spv.name}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Disbale Approval //
    if (["appraiser"].includes(status)) {
      if (user.id) {
        formDisableAppraisal = (
          <FormItem label="On / Off Appraisal" valuePropName="checked">
            {getFieldDecorator("isDisableAppraisal", {
              initialValue: profile ? !profile.isDisableAppraisal : false,
            })(
              <Switch
                defaultChecked={profile ? !profile.isDisableAppraisal : false}
              />
            )}
          </FormItem>
        );
      }
    }

    // Form Button Update //
    let formButtonUpdate = (
      <Row type="flex" justify="end">
        <Col>
          <Button htmlType="submit" type="primary">
            Update
          </Button>
        </Col>
      </Row>
    );

    switch (status) {
      case "sales":
        return (
          <Form onSubmit={this.updateSales}>
            {formName}
            {formNrp}
            {formEmail}
            {formPassword}
            {formPhone}
            {formBranch}
            {formSupervisor}
            {formNoWhatsapp}
            {formBankName}
            {formBankAcc}
            {formBankBeneficiary}
            {formNoKTP}
            {formNoNPWP}
            {formNPWPImage}
            {formKTPImage}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
            {showKTPImage}
            {showNPWPImage}
          </Form>
        );

      case "other":
      case "pricing":
      case "dispatcher":
      case "ali":
      case "general-manager":
      case "finance":
        return (
          <Form onSubmit={this.handleSubmit}>
            {formName}
            {formEmail}
            {formPassword}
            {formPhone}
            {status !== "other" && (
              <RolePicker form={this.props.form} roles={status} />
            )}
            {formButtonUpdate}
          </Form>
        );

      case "appraiser":
        return (
          <Form onSubmit={this.updateAppraiser}>
            {formName}
            {formEmail}
            {formPassword}
            {formPhone}
            {formDisableAppraisal}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
          </Form>
        );

      case "tnt":
      case "branch-head":
        return (
          <Form onSubmit={(e) => this.updateUser(e, status)}>
            {formName}
            {formEmail}
            {formNrp}
            {formPassword}
            {formPhone}
            {formMultipleBranch}
            {status == "branch-head" && (
              <div>
                {formBankName}
                {formBankAcc}
                {formBankBeneficiary}
                {formNoKTP}
                {formNoNPWP}
                {formNPWPImage}
                {formKTPImage}
                {showKTPImage}
                {showNPWPImage}
              </div>
            )}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
          </Form>
        );

      case "supervisor":
        return (
          <Form onSubmit={(e) => this.updateSupervisor(e)}>
            {formName}
            {formEmail}
            {formNrp}
            {formPassword}
            {formPhone}
            {formBranch}
            {formBankName}
            {formBankAcc}
            {formBankBeneficiary}
            {formNoKTP}
            {formNoNPWP}
            {formNPWPImage}
            {formKTPImage}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
            {showKTPImage}
            {showNPWPImage}
          </Form>
        );

      case "mobbi-supervisor":
        return (
          <Form onSubmit={(e) => this.updateUser(e, status)}>
            {formName}
            {formEmail}
            {formPassword}
            {formPhone}
            {formMultipleBranch}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
          </Form>
        );

      case "boh":
        return (
          <Form onSubmit={this.updateBOH}>
            {formName}
            {formEmail}
            {formPassword}
            {formPhone}
            {formArea}
            {formBankName}
            {formBankAcc}
            {formBankBeneficiary}
            {formNoKTP}
            {formNoNPWP}
            {formNPWPImage}
            {formKTPImage}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
            {showKTPImage}
            {showNPWPImage}
          </Form>
        );

      case "abm":
        return (
          <Form onSubmit={this.updateABM}>
            {formName}
            {formEmail}
            {formPassword}
            {formPhone}
            {formArea}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonUpdate}
          </Form>
        );
    }
  }

  render() {
    return (
      <Card title="Update User">
        <Spin tip="Sedang menambahkan User Baru" spinning={this.state.loading}>
          <Tabs
            defaultActiveKey="1"
            onChange={(e) => this.callback(e, this.props)}>
            {this.props.location.query.tabUser ? (
              <TabPane tab={`Update User`} key="1">
                {this.formComponent(this.props.location.query.tabUser)}
              </TabPane>
            ) : (
              <TabPane
                tab={`Update ${this.props.location.query.user} User`}
                key="1">
                {this.formComponent(this.props.location.query.role)}
              </TabPane>
            )}
          </Tabs>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(UserUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/User/UserUpdate.js